import { useBreakpoints } from './useBreakpoints';
/**
 * Passes the `BreakpointsProps` to its children
 *
 * Needs provider for `BreakpointsProps`
 *
 * @example
 * <Media>
 *  {({ currentBreakpoint }) => currentBreakpoint === "desktop" && <div />}
 * </Media>
 */
export function Media(props) {
    var breakpoints = useBreakpoints();
    return props.children(breakpoints);
}
//# sourceMappingURL=Media.js.map